import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
    selector: 'fuse-nav-vertical-item',
    templateUrl: './nav-vertical-item.component.html',
    styleUrls: ['./nav-vertical-item.component.scss']
})
export class FuseNavVerticalItemComponent implements OnInit {
    @HostBinding('class') classes = 'nav-item';
    @Input() item: any;

    constructor(private router: Router) {
    }

    ngOnInit() {
    }
    logout() {
        window.localStorage.removeItem('reportId');
        this.router.navigate(['**']);
    }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/core/components/navigation/vertical/nav-item/nav-vertical-item.component.ts